<template>
  <fragment>
    <v-col cols="2" class="mb-5 pb-5" v-if="showEventInvitePage()">
      <v-btn icon absolute top left class="base ml-1" text @click="returnHome">
        <v-icon color="black">mdi-arrow-left</v-icon>
      </v-btn>
    </v-col>
    <v-card class="my-10 mx-0" flat color="base" height="100%">
      <v-row>
        <v-col cols="12" v-if="showEventInvitePage()">
          <v-card class="px-0 mx-4" flat>
            <v-card-title class="font-weight-bold text-body-1">
              <v-icon
                :color="
                  infoEvent.status == 'ATIVO'
                    ? 'green'
                    : infoEvent.status == 'ESGOTADO' &&
                      infoEvent.status !== 'ATIVO'
                    ? 'blue'
                    : 'red'
                "
                class="mr-1"
                x-small
                >mdi-circle</v-icon
              >
              {{ infoEvent.descricao | cutText(36) }}
            </v-card-title>
            <v-card-subtitle class="text-caption ml-4 pt-1">
              <v-icon small>mdi-calendar</v-icon>
              {{ formatDateTime(infoEvent.dthr_apresentacao) }}
              <v-icon small class="ml-4" v-if="infoEvent.end_local"
                >mdi-map-marker-outline</v-icon
              >
              {{ infoEvent.end_local }}
            </v-card-subtitle>
            <v-tabs
              v-model="tab"
              class="active-class"
              @change="tab == 0 ? getStorage() : ''"
            >
              <v-tabs-slider color="tertiary"></v-tabs-slider>
              <v-tab
                active-class="active-class"
                class="active-class"
                v-for="item in items"
                :key="item"
              >
                {{ item }}
              </v-tab>
            </v-tabs>
          </v-card>
        </v-col>
        <v-col cols="12" v-if="!showEventInvitePage()">
          <v-card flat>
            <v-tabs
              v-model="tab"
              class="active-class"
              @change="tab == 0 ? getStorage() : ''"
            >
              <v-tabs-slider color="tertiary"></v-tabs-slider>
              <v-tab
                active-class="active-class"
                class="active-class text"
                v-for="item in items"
                :key="item"
              >
                {{ item }}
              </v-tab>
            </v-tabs>
          </v-card>
        </v-col>
        <v-col>
          <v-tabs-items v-model="tab" touchless>
            <v-tab-item eager>
              <v-card flat color="base" height="100%">
                <v-card-text class="px-0">
                  <ListInvite />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat color="base" height="100%">
                <v-card-text class="px-0">
                  <InviteForm ref="inviteForm" />
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-card>
  </fragment>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import InviteForm from "@/components/marketing/invitation/form/InviteForm.vue";
import ListInvite from "@/components/marketing/invitation/form/inviteList.vue";
import displayHelpers from "@/mixins/breakpoints.mixins";
import { formatDate } from "@/utils";
export default {
  name: "InviteResume",
  mixins: [displayHelpers],
  components: {
    InviteForm,
    ListInvite,
  },
  data() {
    return {
      tab: 0,
      formatDate,
    };
  },
  computed: {
    ...mapGetters(["inviteEvent", "statusTab"]),
    ...mapMutations(["setTab"]),
    items() {
      return [
        this.$t("marketing.invitation.invitations"),
        this.$t("marketing.invitation.create-invitation"),
      ];
    },
    infoEvent() {
      return JSON.parse(localStorage.getItem("eventoData"));
    },
  },
  methods: {
    ...mapActions(["fetchInviteEvent"]),
    returnHome() {
      this.$router.push("/marketing/convite");
    },
    formatDateTime(dateTime) {
      const formattedDate = formatDate(dateTime);
      const dayOfWeek = this.getDayOfWeek(dateTime);
      return ` ${dayOfWeek}, ${formattedDate}`;
    },
    getDayOfWeek(dateTime) {
      const daysOfWeek = [
        "Domingo",
        "Segunda",
        "Terça",
        "Quarta",
        "Quinta",
        "Sexta",
        "Sábado",
      ];
      const date = new Date(dateTime);
      const dayIndex = date.getDay();
      return daysOfWeek[dayIndex];
    },
    colorStatus() {
      return this.infoEvent.status == "ATIVO"
        ? "green"
        : this.iinfoEvent.status == "ESGOTADO" &&
          this.iinfoEvent.status !== "ATIVO"
        ? "blue"
        : "red";
    },
    getStorage() {
      const idproduto = this.infoEvent?.idproduto;
      const tipo = this.infoEvent !== null ? "EVENTO" : "PRODUTOR";
      let params = {
        idproduto,
        tipo,
      };
      if (this.infoEvent !== null) {
        return this.fetchInviteEvent(params);
      } else {
        return this.fetchInviteEvent(params);
      }
    },
    showEventInvitePage() {
      if (this.infoEvent !== null) {
        return true;
      }
      return false;
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    tab(newVal, oldVal) {
      if (newVal === 0) {
        this.$refs.inviteForm.resetFields();
      }
    },
    "$store.getters.statusTab"(val) {
      if (val == 1) {
        this.tab = 0;
        this.getStorage();
      }
    },
  },
  mounted() {
    this.getStorage();
  },
};
</script>

<style>
.v-tabs--vertical > .v-tabs-bar .v-tabs-slider {
  height: 100%;
  width: 5px !important;
}
.active-class {
  border-radius: 10px !important;
  font-weight: bold !important;
  font-size: 12px !important;
  transition: all 0.2s ease-in-out !important;
}
.active-class:hover {
  border-radius: 10px !important;
  font-weight: bold !important;
  transition: all 0.2s ease-in-out !important;
}
</style>
